// Webpack is weird... If I put this directly in main.js, it's executed *after*
// all the other imports are required, even if it comes *before* the import
// statements in the file.

const disabled = process.env.HONEYBADGER_ENVIRONMENT !== 'production';

Honeybadger.configure({
  apiKey: '559b304e',
  endpoint: 'https://titanic.honeybadger.io',
  environment: process.env.HONEYBADGER_ENVIRONMENT,
  reportData: !disabled,
  revision: process.env.HONEYBADGER_REVISION,
  breadcrumbsEnabled: !disabled,
})

Honeybadger.setContext({
  version: (function() {
    if (typeof(Honeybadger.getVersion) === 'function') {
      return Honeybadger.getVersion()
    } else {
      return Honeybadger.version
    }
  })()
})

Honeybadger.beforeNotify(() => !/detectify/i.test(navigator.userAgent));

const ignoredStacks = /chrome-extension|convertkit|netlify|wistia|usefathom/i;
Honeybadger.beforeNotify(notice => !ignoredStacks.test(notice.stack));

window.Honeybadger = Honeybadger
